import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { DashboardPayload } from '@flux/shared';
import { queryKeys } from '@/lib/query/keys.js';
import { fetchDashboardPayload } from './api.js';

/**
 * Tableau de bord (`02` §2) : « voir en dix secondes si le flux est sain » —
 * un polling léger (30 s, même ordre de grandeur que le bandeau maintenance
 * et le badge « Commandes », `README-shell.md`) garde l'écran à jour sans
 * action de l'utilisateur.
 */
export function useDashboardPayload(period?: { from: string; to: string }): UseQueryResult<DashboardPayload> {
  return useQuery({
    queryKey: queryKeys.dashboard.payload(period),
    queryFn: () => fetchDashboardPayload(period),
    refetchInterval: 30_000,
  });
}
